import toString from 'lodash/toString';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { sendTrackingEvent } from 'tracking/utils';

/**
 * [setUserGoatId]
 * A function that sets the user GOAT_user_id attribute
 * @param  {Object} user           user object
 */
export function mParticleSetUserGoatId({ user, eventContext = '', accountCreation = false }) {
  try {
    if (typeof window === 'undefined') return;
    window?.mParticle?.Identity?.getCurrentUser()?.setUserAttribute(
      'GOAT_user_id',
      user ? user?.id : null,
    );
    window?.mParticle?.Identity?.getCurrentUser()?.setUserAttribute(
      'guest_user',
      Boolean(user?.isGuest) || !user?.id,
    );

    if (accountCreation) {
      sendTrackingEvent('CREATE_ACCOUNT_TAP', {
        user_id: toString(user?.id),
        event_context: eventContext,
      });
    }
  } catch (error) {
    bugsnag(error, { context: 'mParticle GOAT_user_id' });
  }
}

/**
 * [mParticleSetGuestUserAttr]
 * A function that sets the user guest_user attribute
 * @param  {Object} user           user object
 */
export function mParticleSetGuestUserAttr(user) {
  try {
    if (typeof window === 'undefined') return;
    window?.mParticle?.Identity?.getCurrentUser()?.setUserAttribute(
      'guest_user',
      Boolean(user?.isGuest) || !user?.id,
    );
  } catch (error) {
    bugsnag(error, { context: 'mParticle guest_user' });
  }
}

/**
 * [setUserLoggedIn]
 * A function that sets the current user logged in in mParticle
 * @param  {Object} user           user object
 */
export function mParticleSetUserLoggedIn({ user, eventContext, accountCreation }) {
  const loginRequest = {
    userIdentities: {
      email: toString(user?.email),
      customerid: toString(user?.id),
    },
  };

  try {
    if (typeof window === 'undefined') return;
    window?.mParticle?.Identity?.login(loginRequest, () => {
      mParticleSetUserGoatId({ user, eventContext, accountCreation });
      mParticleSetGuestUserAttr(user);
    });
  } catch (error) {
    bugsnag(error, { context: 'mParticle Login Request' });
  }
}

/**
 * [setUserLoggedOut]
 * A function that sets the current user logged out in mParticle
 */
export function mParticleSetUserLoggedOut() {
  const logoutRequest = {
    userIdentities: {},
  };

  try {
    if (typeof window === 'undefined') return;
    window?.mParticle?.Identity?.logout(logoutRequest, () => {
      mParticleSetGuestUserAttr({});
    });
  } catch (error) {
    bugsnag(error, { context: 'mParticle Logout Request' });
  }
}
